import {Component, OnInit, OnDestroy} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {CheckhrService} from '../service/checkhr.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Subscription} from 'rxjs/Subscription';
import {Router} from '@angular/router';
import {UserContext, User, BaseComponent, ElCheckhr, CheckhrUser} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';
import {Message} from 'primeng/components/common/api';

declare var $: any;

@Component({
  selector: 'app-checkhr-user',
  templateUrl: './checkhr-user.component.html',
  styleUrls: ['./checkhr-user.component.css'],
})
export class CheckhrUserComponent extends BaseComponent implements OnInit, OnDestroy {
  static DIALOG_ID = 'CheckhrUserDialog';
  private subscriptions: Subscription[] = [];

  locale: any = AppConstants.ITA_CALENDAR_CONF;
  user: User = null;
  userContext: UserContext;
  elements: CheckhrUser[] = [];
  loading = false;
  filteredElements: CheckhrUser[] = [];
  onlyActive = true;
  elementSelected: CheckhrUser = new CheckhrUser();
  validationMessage: string = null;
  showDeleteAlert = false;
  oggi: Date = new Date();

  checkhrs: SelectItem[] = [];

  elementData: Date = new Date();
  elementId: number = null;
  elementNote: string = null;

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private checkhrService: CheckhrService,
    private busyProvider: BusyProvider) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      for (let i = 0; i < this.subscriptions.length; ++i) {
        this.subscriptions[i].unsubscribe();
      }
    }
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.subscriptions[0] = this.checkhrService.getCheckhrUserComponentStatus().subscribe(
        user => {
          if (user != null) {
            this.user = user;
            $('#' + CheckhrUserComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
            this.loadCheckhr();
            this.loadCheckhrUser();
          } else {
            this.close();
          }
        }
      );
    }
  }

  filterElements() {
    this.filteredElements = [];
    for (let i = 0; i < this.elements.length; ++i) {
      const current = this.elements[i];
      if (this.onlyActive && +new Date(current.dataScadenza) > +this.oggi) {
        this.filteredElements.push(this.elements[i]);
      } else if (!this.onlyActive) {
        this.filteredElements.push(this.elements[i]);
      }
    }
  }

  loadCheckhr() {
    this.checkhrs = [];
    this.checkhrService.getCheckhrElements(this.userContext.srmToken).subscribe(
      result => {
        const checkhrs = result.elements;
        for (let i = 0; i < checkhrs.length; ++i) {
          const current: ElCheckhr = checkhrs[i];
          this.checkhrs.push({label: current.desc, value: current.id});
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadCheckhrUser() {
    this.elements = [];
    this.loading = true;
    this.checkhrService.getCheckhrUsers(this.userContext.srmToken, null, this.user.id).subscribe(
      result => {
        this.elements = result.checkhrs;
        this.elements.sort(function(a, b) {
          return +new Date(a.dataScadenza) - +new Date(b.dataScadenza);
        });
        this.loading = false;
        if (this.elementSelected != null && this.elementSelected.idElCheckhr > 0) {
          this.selectElement(this.elementSelected);
        }
        this.filterElements();
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  selectElement(element: CheckhrUser) {
    this.validationMessage = null;
    this.elementSelected = element;
    this.elementData = element.data;
    this.elementId = element.idElCheckhr;
    this.elementNote = element.note;
  }

  addNewCheckhrUser() {
    this.validationMessage = null;
    this.messageProvider.clearAll();
    this.elementSelected = new CheckhrUser();
    this.elementData = new Date();
    this.elementId = this.checkhrs.length > 0 ? this.checkhrs[0].value : 0;
    this.elementNote = null;
  }

  storeCheckhrUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.elementData == null) {
      this.validationMessage = 'Inserire la data';
      return;
    }
    if (this.elementId == null || this.elementId === 0) {
      this.validationMessage = 'Selezionare la scadenza';
      return;
    }

    // modifica
    if (this.elementSelected.idElCheckhr > 0) {
      this.busyProvider.showBusyIndicator();
      this.checkhrService.updateNoteCheckhrUser(this.userContext.srmToken, this.elementSelected.data, this.elementSelected.idUser,
        this.elementSelected.idElCheckhr, this.elementSelected.dataScadenza, this.elementNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Modifica eseguita correttamente'});
          this.loadCheckhrUser();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    } else { // inserimento
      this.busyProvider.showBusyIndicator();
      this.checkhrService.insertCheckhrUser(this.userContext.srmToken, this.elementData, this.user.id, this.elementId, null, this.elementNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Scadenza inserita correttamente'});
          this.loadCheckhrUser();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    }
  }

  openDeleteAlert(current: CheckhrUser) {
    this.selectElement(current);
    this.showDeleteAlert = true;
  }
  
  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  deleteCheckhrUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    this.busyProvider.showBusyIndicator();
    this.checkhrService.deleteCheckhrUser(this.userContext.srmToken, this.elementSelected.data, this.elementSelected.idUser,
      this.elementSelected.idElCheckhr, this.elementSelected.dataScadenza).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
        this.addNewCheckhrUser();
        this.loadCheckhrUser();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  close() {
    $('#' + CheckhrUserComponent.DIALOG_ID).modal('hide');
    this.user = null;
  }

  getRowClass(current: CheckhrUser) {
    let styleClass = '';
    if (current.data === this.elementSelected.data && current.idElCheckhr === this.elementSelected.idElCheckhr) {
      styleClass += 'selectedRow ';
    }
    if (+new Date(current.dataScadenza) < +this.oggi) {
      let maxData: Date = null;
      for (const element of this.elements) {
        if (element.idElCheckhr === current.idElCheckhr && element.idUser === current.idUser) {
          maxData = (maxData == null || +new Date(maxData) < +new Date(element.data)) ? element.data : maxData;
        }
      }
      if (current.data === maxData) {
        styleClass += 'inScadenza ';
      } else {
        styleClass += 'scaduto ';
      }
    } else {
      if ((new Date(current.dataScadenza).getTime() - (1000 * 60 * 60 * 24 * current.elCheckhr.numGiorniAlert)) < +this.oggi) {
        styleClass += 'inScadenza ';
      }
    }
    return styleClass;
  }

}



// WEBPACK FOOTER //
// ./src/app/checkhr-user/checkhr-user.component.ts